import styled from 'styled-components';
import { ASSETS } from 'utils/config';

export const ModalContainerSuccess = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 50vw;
  box-shadow: 24px 24px 48px rgba(0, 0, 0, 0.2);
  padding: 50px 20px 40px 20px; /* Increase top padding for the wheel */
  border-radius: 14px;
  background-color: white;
  background-size: cover;
  position: relative;
  text-align: center;
`;

export const IconWrapper = styled.div`
  position: absolute; /* Positioned relative to the modal */
  top: 10px; /* Distance from the top of the modal */
  right: 10px; /* Distance from the right of the modal */
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px; /* Adjust the size */
  height: 24px;
  cursor: pointer; /* Show pointer cursor for interactivity */
  color: #1976d2; /* Custom color for the icon */
  z-index: 100; /* Ensure it appears above modal content */

  &:hover {
    color: #ff0000; /* Optional hover effect for better UX */
  }
`;

export const TopIcon = styled.div`
  width: 60px; /* Adjust size */
  height: 60px; /* Adjust size */
  background-image: url(${ASSETS.NewAiIcon});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  margin: 0 auto 20px auto; /* Center and position the icon */
  position: relative; /* Keeps the wheel icon inside the modal */
`;

export const ModalContentSuccess = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;
